import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GtmTagService } from './gtm-tag.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  loading = true;

  constructor(router: Router, private toastr: ToastrService, private gtmService: GtmTagService) {
    router.events.forEach((e) => {
      let tmOut: any;
      if (e instanceof NavigationStart) {
        tmOut = setTimeout(() => {
          this.loading = true;
        }, 300);
      } else if (e instanceof NavigationEnd) {
        const url = window.location.href;

        if (this.elegivelPageView(url)) {
          const gtmTag = {
            event: 'pageView',
            page: {
              url,
              path: this.getPath()
            }
          };
          this.gtmService.pushTag(gtmTag);
        }
      }
      clearTimeout(tmOut);
      this.loading = false;
    });
  }

  getPath() {
    let path = '/minhacea' + window.location.hash?.replace('#/', '/');
    path = this.tratarPath(path);
    return path;
  }

  tratarPath(path: string): string {
    const rotas = ['alterar-senha'];
    rotas.forEach(() => {
      const index = path.indexOf('?');
      if (index >= 0) {
        path = path.substring(0, index);
        return;
      }
    });
    return path;
  }

  elegivelPageView(url: string): boolean {
    return url.indexOf('/page/admin') < 0;
  }
}
